// Password rules
// - 6 or more characters
// - No spaces
export const REGEX_PASSWORD_RULES = /^\S{6,}$/
